import React, { Dispatch, FC, SetStateAction } from "react";
import FeatherIcon from "feather-icons-react";

import { Button, Stack, Typography } from "@components/base";

interface Paging {
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
}

const Paging: FC<Paging> = ({ page, setPage }) => (
  <Stack
    direction="row"
    spacing={2}
    justifyContent="flex-end"
    alignItems="center"
    p={3}
  >
    <Button
      variant="contained"
      size="small"
      onClick={() => setPage(page - 1)}
      disabled={page === 0}
    >
      <FeatherIcon icon="chevron-left" />
    </Button>
    <Typography>{page + 1}</Typography>
    <Button variant="contained" size="small" onClick={() => setPage(page + 1)}>
      <FeatherIcon icon="chevron-right" />
    </Button>
  </Stack>
);

export default Paging;
